import { createSlice } from "@reduxjs/toolkit";
import { getTaskMaster } from "../reduxApi/taskMasterReduxApi";
const taskMasterlice = createSlice({
    name: 'taskMaster',
    initialState: {
        status: 'idel',
        taskMaster: [],
        filteredDashboardTasksStatus: false,  //  new
        isFiltered: false,

    },
    reducers: {
          setFilteredStatus: (state, action) => {
            state.isFiltered = action.payload;
        },
        deleteTaskMasterAction: (state, action) => {
            action.payload.forEach((id) => {
                const index = state.taskMaster.findIndex((item) => item?.ROWID === id);
                if (index !== -1) {
                    state.taskMaster.splice(index, 1);
                }
            });
        },

        updateTaskMasterAction: (state, action) => {
            state.taskMaster = state.taskMaster.map((item) =>
                item.ROWID === action.payload.ROWID
                    ? { ...item, ...action.payload }
                    : item
            );
        },

        addTaskMasterAction: (state, action) => {
            console.log("Adding taskMaster:", action.payload);
            const temp = action.payload.formData;
            temp.ROWID = action.payload.ROWID
            state.taskMaster.unshift({ taskMaster: temp });
        },
        //  NEW
        setFilteredDashboardTasks: (state, action) => {
            const isSame =
                JSON.stringify(state.taskMaster) === JSON.stringify(action.payload);

            if (!isSame) {
                state.taskMaster = action.payload;
            }

            state.filteredDashboardTasksStatus = true;
        },

        clearFilteredDashboardTasks: (state) => {
            state.filteredDashboardTasksStatus = false;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getTaskMaster.pending, (state, action) => {
            state.status = 'pending'
        })
            .addCase(getTaskMaster.fulfilled, (state, action) => {
                state.status = 'fulfilled'
                console.log("testing taskMaster Data", action.payload)
                state.taskMaster = action.payload.data.response;

            })
    }
})
export const { deleteTaskMasterAction, updateTaskMasterAction, addTaskMasterAction, setFilteredDashboardTasks,
    clearFilteredDashboardTasks,setFilteredStatus } = taskMasterlice.actions
export default taskMasterlice.reducer

